export default class {
  static getPoints() {
    // TODO Move this to a shared variable
    const activeConfigurator = document.getElementById('activeConfiguratorId').value;
    const language = document.getElementById('currentLanguage').value;
    return fetch(`/api/configurator/points?activeConfigurator=${activeConfigurator}&language=${language}`)
      .then(this.validateResponse)
      .then(this.readResponseAsJson)
      .catch(this.handleError);
  }

  static getProducts() {
    const activeConfigurator = document.getElementById('activeConfiguratorId').value;
    const language = document.getElementById('currentLanguage').value;
    return fetch(`/api/configurator/products?activeConfigurator=${activeConfigurator}&language=${language}`)
      .then(this.validateResponse)
      .then(this.readResponseAsJson)
      .catch(this.handleError);
  }

  static getCategories() {
    const activeConfigurator = document.getElementById('activeConfiguratorId').value;
    const language = document.getElementById('currentLanguage').value;
    return fetch(`/api/configurator/categories?activeConfigurator=${activeConfigurator}&language=${language}`)
      .then(this.validateResponse)
      .then(this.readResponseAsJson)
      .catch(this.handleError);
  }

  static getDepths() {
    const activeConfigurator = document.getElementById('activeConfiguratorId').value;
    const language = document.getElementById('currentLanguage').value;
    return fetch(`/api/configurator/depths?activeConfigurator=${activeConfigurator}&language=${language}`)
      .then(this.validateResponse)
      .then(this.readResponseAsJson)
      .catch(this.handleError);
  }

  static getSearch() {
    const activeConfigurator = document.getElementById('activeConfiguratorId').value;
    const language = document.getElementById('currentLanguage').value;
    return fetch(`/api/configurator/search?activeConfigurator=${activeConfigurator}&language=${language}`)
      .then(this.validateResponse)
      .then(this.readResponseAsJson)
      .catch(this.handleError);
  }

  static getFilter() {
    const activeConfigurator = document.getElementById('activeConfiguratorId').value;
    const language = document.getElementById('currentLanguage').value;
    return fetch(`/api/configurator/filter?activeConfigurator=${activeConfigurator}&language=${language}`)
      .then(this.validateResponse)
      .then(this.readResponseAsJson)
      .catch(this.handleError);
  }

  static validateResponse(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  }

  static readResponseAsJson(response) {
    return response.json();
  }

  static handleError() {
    console.log('Error fetching data');
  }
}